import React from 'react'
import styles from './wrapper.styles'
import injectSheet from 'react-jss'

const Wrapper = ({ classes, children }) => (
  <div className={classes.wrapper}>{children}</div>
)

export default injectSheet(styles)(Wrapper)
